export default savedData => {
  const { formData } = savedData;

  if (
    !Object.prototype.hasOwnProperty.call(
      formData,
      'view:hasMilitaryRetiredPay',
    )
  ) {
    return savedData;
  }

  const { 'view:hasMilitaryRetiredPay': oldKeyVal, ...restOfFormData } =
    formData;

  const updatedFormData = {
    hasMilitaryRetiredPay: oldKeyVal,
    ...restOfFormData,
  };

  return {
    ...savedData,
    formData: updatedFormData,
  };
};
